export default __webpack_public_path__ + "static/media/pic2.47959068.jpg";